import { useEffect } from 'react';

export const useAsyncEffect = (effect: () => Promise<void> | Promise<() => void>, deps: React.DependencyList) => {
    useEffect(() => {
        effect();
    }, deps);
};
